/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Faq_Team_QInputs */

const en_platform_faq_team_q = /** @type {(inputs: Platform_Faq_Team_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I work with other trainers. Does that work?`)
};

const pl_platform_faq_team_q = /** @type {(inputs: Platform_Faq_Team_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pracuję z innymi trenerami. Czy to zadziała?`)
};

/**
* | output |
* | --- |
* | "I work with other trainers. Does that work?" |
*
* @param {Platform_Faq_Team_QInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_faq_team_q = /** @type {((inputs?: Platform_Faq_Team_QInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Faq_Team_QInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_faq_team_q(inputs)
	return en_platform_faq_team_q(inputs)
});